import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth'; // لاستخدام اسم المستخدم
import { useQuery } from '@tanstack/react-query';
import { getMyServiceRequests } from '../../services/serviceRequestService';
import LoadingSpinner from '../../components/common/LoadingSpinner';
// استيراد ملفات التنسيق
import pageStyles from '../Page.module.css'; // تنسيقات الصفحة العامة
import dashboardStyles from './SubscriberDashboard.module.css'; // تنسيقات خاصة بهذه الصفحة

const SubscriberDashboard: React.FC = () => {
  const { user } = useAuth();

   // !! استخدام الاستعلام الجديد !!
  const { data: myRequests, isLoading } = useQuery({
    // استخدام queryKey الذي سنقوم بإبطاله
    queryKey: ['myServiceRequests', user?.id],
    queryFn: getMyServiceRequests,
    enabled: !!user,
  });
  if (isLoading) {
    return <LoadingSpinner />;
  }
  // ابحث عن طلب الالتحاق بالتدريب (نفترض أن service_id الخاص به هو 1)
  const trainingRequest = myRequests?.find(req => req.service_id === 1);

  // في المستقبل، سنتحقق هنا من حالة طلب التدريب
 // const hasAppliedForTraining = false; // قيمة مؤقتة

  return (
    <div className={pageStyles.pageContainer}>
      <h1 className={pageStyles.pageTitle}>
        مرحباً بك، {user?.registration_payload?.name || user?.email}!
      </h1>
      <p className={dashboardStyles.welcomeMessage}>
        أنت الآن مشترك جديد. خطوتك التالية هي تقديم طلب للالتحاق ببرنامج التدريب لتصبح متدرباً رسمياً.
      </p>

      <div className={dashboardStyles.card}>
        <h2 className={dashboardStyles.cardTitle}>طلب الالتحاق بالتدريب</h2>
           {trainingRequest ? (
          <div>
            <p className={dashboardStyles.statusText}>
              حالة طلبك الحالي: <span className={dashboardStyles.statusPending}>{trainingRequest.status}</span>
            </p>
            <p>سيتم إعلامك فور مراجعة طلبك من قبل الإدارة.</p>
          </div>
        ) : (
          <div>
            <p>انقر على الزر أدناه لتقديم طلبك وبدء رحلتك المهنية.</p>
            {/* هذا الرابط سيرتبط بصفحة النموذج التي سننشئها في الخطوة التالية */}
            <Link to="/subscriber/training-application" className={dashboardStyles.applyButton}>
              قدم طلب الالتحاق بالتدريب الآن
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriberDashboard;
